const balanceRoutes = [
  {
    path: "/balanceSet",
    name: "balanceSet",
    component: () => import("@/views/balance/balanceSet.vue"),
    meta: {
      title: "折扣配置",
    },
  },
  {
    path: "/balanceRecharge",
    name: "balanceRecharge",
    component: () => import("@/views/balance/balanceRecharge.vue"),
    meta: {
      title: "充值列表",
      keepAlive: true,
    },
  },
  {
    path: "/balanceWithdraw",
    name: "balanceWithdraw",
    component: () => import("@/views/balance/balanceWithdraw.vue"),
    meta: {
      title: "提现列表",
      keepAlive: true,
    },
  },
  {
    path: "/balanceChange",
    name: "balanceChange",
    component: () => import("@/views/balance/balanceChange.vue"),
    meta: {
      title: "变动记录",
      keepAlive: true,
    },
  },
];

export default balanceRoutes;
